import React from 'react';
import './styles.css';
import isEqual from 'lodash';
import { changeRupiahToNegativeFloat } from 'utils/formatter';

class TableScrollHorizontalVertical extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      sort: {
        column: null,
        direction: 'desc',
      },
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    this._handleWindowHeight(
      nextProps.fTueStatus,
      nextProps.fTueStatusCategory
    );
    return isEqual(nextState.sort.direction, this.state.sort.direction);
  }

  componentDidMount() {
    const divScroll = $('.div-scroll');
    const tableScroll = $('.table-scroll');
    const tbodyInner = $('#tbodyinner');
    divScroll.scroll(this._handleScroll);
    tableScroll.scroll(this._handleTableScroll);
    tbodyInner.scroll(this._handleTbodyInner);
    this._handleWindowHeight(
      this.props.fTueStatus,
      this.props.fTueStatusCategory
    );
  }

  componentWillMount = () => {
    const dataParentBody = this.props.parentBody;
    const dataChildBody = this.props.childBody;
    const { parentHeader } = this.props;
    const data = [];
    for (let i = 0; i < dataParentBody.length; i++) {
      const concateTheData = {
        [parentHeader.toLowerCase()]: dataParentBody[i],
        ...dataChildBody[i],
      };
      data.push(concateTheData);
    }
    this.setState({ data });
    window.addEventListener(
      'resize',
      this._handleWindowHeight(
        this.props.fTueStatus,
        this.props.fTueStatusCategory
      )
    );
  };

  componentWillUnmount = () => {
    window.removeEventListener(
      'resize',
      this._handleWindowHeight(
        this.props.fTueStatus,
        this.props.fTueStatusCategory
      )
    );
  };

  _contentHeightInterval = () => {
    return setInterval(function() {
      this._handleWindowHeight(
        this.props.fTueStatus,
        this.props.fTueStatusCategory
      );
    }, 100);
  };

  _handleScroll = () => {
    const divScroll = $('.div-scroll');
    document.getElementById('tbodyinner').scrollLeft = divScroll.scrollLeft();
  };

  _handleTableScroll = () => {
    const tableScroll = $('.table-scroll');
    const widthDiv = tableScroll.scrollLeft() + tableScroll.width();
    document.getElementById('tbodyinner').style.width = `${widthDiv}px`;
  };

  _handleTbodyInner = () => {
    const tbodyInner = $('#tbodyinner');
    document.getElementById('tbodydiv').scrollTop = tbodyInner.scrollTop();
  };

  _handleWindowHeight = (fTueStatus, fTueStatusCategory) => {
    const bodyHeight = $(window).height();
    let contentHeight;
    if (fTueStatus === true || fTueStatusCategory === true) {
      contentHeight = bodyHeight - 350;
    } else {
      contentHeight = bodyHeight - 226;
    }
    $('.div-scroll > .table-scroll tbody').css(
      'max-height',
      `${contentHeight}px`
    );
    $('.div-static > .table-static tbody').css(
      'max-height',
      `${contentHeight}px`
    );
    if (
      $('.div-scroll > .table-scroll tbody').css('max-height') ===
        `${contentHeight}px` &&
      $('.report-table-outer').hasClass('element-non-mobi')
    ) {
      clearInterval(this._contentHeightInterval);
    }
  };

  _setArrow = column => {
    let className = 'sort-direction';

    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? ' asc' : ' desc';
    } else {
      className += ' normal';
    }
    return className;
  };

  static _formatterNameColumn(column) {
    const regex = /\s/g;
    return column.toLowerCase().replace(regex, '_');
  }

  _onSort = column => () => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState({
      sort: {
        direction,
      },
    });

    column = TableScrollHorizontalVertical._formatterNameColumn(column);
    if (column === 'discount_amount' && this.props.accessedBy === 'discount') {
      column = 'amount';
    } else if (
      column === 'gross_discount' &&
      this.props.accessedBy === 'discount'
    ) {
      column = 'discount_applied';
    } else if (
      column === 'discount_refunded' &&
      this.props.accessedBy === 'discount'
    ) {
      column = 'refund';
    }
    /* Intl.Collator for compare string numeric */
    const collator = new Intl.Collator(undefined, {
      numeric: true,
      sensitivity: 'base',
    });
    const sortedData = this.state.data.sort((a, b) => {
      if (
        a[column].toString().indexOf('Rp.') === -1 ||
        b[column].toString().indexOf('Rp.') === -1
      ) {
        return collator.compare(a[column].toString(), b[column].toString());
      }
      return (
        changeRupiahToNegativeFloat(a[column]) -
        changeRupiahToNegativeFloat(b[column])
      );
    });
    if (direction === 'desc') {
      sortedData.reverse();
    }

    this.setState({
      data: sortedData,
      sort: {
        column,
        direction,
      },
    });
  };

  parentFooter = (parentClassName, parentBody, parentHeader, parentFoot) => (
    <div className="div-static">
      <table className="table table-static">
        <thead className={parentClassName[0]}>
          <tr>
            <th>{parentHeader}</th>
          </tr>
        </thead>
        <tbody id="tbodydiv" className={parentClassName[1]}>
          {parentBody.map((val, pidx) => {
            return (
              <tr key={pidx}>
                <td>{val}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot className={parentClassName[2]}>
          <tr>
            <td className="text-left">
              <strong>{parentFoot}</strong>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );

  render() {
    const {
      parentHeader,
      parentFoot,
      childFixedBody,
      childHeaders,
      childFoot,
      parentClassName,
      childHeaderClassName,
      childBodyClassName,
      childFootClassName,
    } = this.props;
    return (
      <div
        id="report-sales-scroll"
        className="report-table-outer report-table-sales visible-md visible-lg"
      >
        <div className="div-static">
          <table className="table table-static">
            <thead className={parentClassName[0]}>
              <tr>
                <th onClick={this._onSort(parentHeader.toLowerCase())}>
                  {parentHeader}
                  <span
                    className={this._setArrow(parentHeader.toLowerCase())}
                  />
                </th>
              </tr>
            </thead>
            <tbody id="tbodydiv" className={parentClassName[1]}>
              {this.state.data.map((val, pidx) => {
                return (
                  <tr key={pidx}>
                    <td>{val[parentHeader.toLowerCase()]}</td>
                  </tr>
                );
              })}
            </tbody>
            {parentFoot && (
              <tfoot className={parentClassName[2]}>
                <tr>
                  <td className="text-left">
                    <strong>{parentFoot}</strong>
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
        <div className="div-scroll">
          <table className="table table-scroll">
            <thead>
              <tr>
                {childHeaders.map((val, pidx) => {
                  return (
                    <th
                      key={pidx}
                      className={childHeaderClassName[pidx]}
                      onClick={this._onSort(
                        TableScrollHorizontalVertical._formatterNameColumn(val)
                      )}
                    >
                      {val}
                      <span
                        className={this._setArrow(
                          TableScrollHorizontalVertical._formatterNameColumn(
                            val
                          )
                        )}
                      />
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody id="tbodyinner">
              {this.state.data.map((val, bodyIndex) => {
                const valObj = Object.values(val);
                return (
                  <tr key={bodyIndex}>
                    {valObj.map((value, pidx) => {
                      return pidx === 0 ? (
                        ''
                      ) : (
                        <td className={childBodyClassName[pidx - 1]} key={pidx}>
                          {value}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>

            {Object.values(childFoot).length > 0 && (
              <tfoot id="tfootscroll">
                <tr className="text-total">
                  {Object.values(childFoot).map((value, pidx) => {
                    return (
                      <td className={childFootClassName[pidx]} key={pidx}>
                        <b>{value}</b>
                      </td>
                    );
                  })}
                </tr>
              </tfoot>
            )}
          </table>
        </div>
        {childFixedBody ? this.parentFooter() : null}
      </div>
    );
  }
}

export default TableScrollHorizontalVertical;
